var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKemuBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 165 207",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#2f2e3c;}.b{fill:#badfff;}.c{fill:#63626d;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124 201.9c0 2.4-18.8 4.3-42 4.3 -23.2 0-42-1.9-42-4.3 0-2.4 18.8-4.3 42-4.3 23.2 0 42 1.9 42 4.3Z",
    fill: "#e5e5e5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.2 78.2c0 6.1-4.3 11.5-9.8 13.4 -3.6 11.4-10.8 20.3-20.5 26.7 0 0 0 0 0 0 2.1 4.1 3.8 9.1 4.7 14.5 2.8 16.2-1.7 30.5-10.2 32 -2.1 0.4-4-0.3-5.8-1.8 0 0 0 0 0 0 -1.8 3.7-3.9 7.1-6.3 10.2 -8.3 10.8-20.3 17.8-33.7 17.8 -13.4 0-25.4-7-33.8-17.8 -2.5-3.2-4.6-6.7-6.5-10.4l0 0c-1.8 1.6-3.8 2.3-5.9 1.9 -8.5-1.5-13.1-15.8-10.2-32 0.9-5.2 2.6-10.3 4.6-14.3 -9.8-6.5-17-15.4-20.6-26.7 -5.5-1.9-10.1-7.4-10.1-13.5l0-16.7c0-7.1 5.3-12.9 12.2-13.8 0 0 0 0 0 0 10.4-27.2 36.9-47.7 70.1-47.7 32.5 0 58.6 19.6 69.5 46 0 0 0 0 0 0l0-18.5c-2.6-1.1-4.4-3.7-4.4-6.6 0-4 3.2-7.2 7.2-7.2 4 0 7.2 3.2 7.2 7.2 0 3-1.8 5.5-4.4 6.6l0 22c4.1 2.4 6.9 6.9 6.9 12l0 16.7Z",
    className: "a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.3 86.1c0 23.6-24.7 35.1-59 35.1 -34.3 0-59-11.5-59-35.1 0-26.1 24.7-47.2 59-47.2 34.3 0 59 21.1 59 47.2Z",
    className: "b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M141.3 86.1c0-22.2-18-40.9-44.6-45.9 25.8 5.6 43.1 24 43.1 45.9 0 17.5-13.5 28.5-34.5 33 21.8-4.3 36-15.2 36-33.1Z",
    className: "b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 84.6c0-18.9 11.6-35.1 31.8-42.7 -22.8 6.7-37.7 24-37.7 44.2 0 23.6 24.7 35.1 59 35.1 13.5 0 25.5-1.8 35.1-5.4 -8.7 2.6-19.1 3.9-30.5 3.9 -34.3 0-57.7-11.5-57.7-35.1Z",
    className: "b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 52.4c-3.5 1.7-6 5.3-6 9.5l0 15.6c0 1.7 0.4 3.3 1.2 4.8l1.3-20.7c0.3-3.8 0.6-6.9 3.5-9.2Z",
    className: "c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7 77.8c-3.9 0-7-3.1-7-7 0-1.1 0.2-2.1 0.7-3 -1.3-0.4-2.6-0.7-4.1-0.7 -7 0-12.6 5.6-12.6 12.6 0 7 5.6 12.6 12.6 12.6 7 0 12.6-5.6 12.6-12.6 0-0.8-0.1-1.5-0.2-2.3 -0.6 0.2-1.3 0.3-2 0.3Z",
    className: "a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M122.3 77.8c-3.9 0-7-3.1-7-7 0-1.1 0.2-2.1 0.7-3 -1.3-0.4-2.6-0.7-4.1-0.7 -7 0-12.6 5.6-12.6 12.6 0 7 5.6 12.6 12.6 12.6 7 0 12.6-5.6 12.6-12.6 0-0.8-0.1-1.5-0.2-2.3 -0.6 0.2-1.3 0.3-2 0.3Z",
    className: "a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91 104.3c-7 1.2-10.6 1.2-17.5 0 -1.7-0.3-3.4 0.7-3.8 2.4 -0.4 1.7 0.8 3.4 2.7 3.7 7.8 1.4 11.9 1.4 19.7 0 1.9-0.3 3.1-2.1 2.7-3.7 -0.4-1.7-2.1-2.7-3.8-2.4Z",
    className: "a"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158.9 21.6c-1 1-2.8 0.7-4.1-0.6 -1.3-1.3-1.6-3.2-0.6-4.1 1-1 2.8-0.7 4.1 0.6 1.3 1.3 1.6 3.2 0.6 4.1Z",
    className: "b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 77.9c0.1-1.1 0.1-2.2 0.1-3.3 0-36.7-30-69.1-70.5-69.1 -16.1 0-30.5 5.1-42.1 13.6 11.1-6.6 24.1-10.5 38.5-10.5 41.4 0 72.3 32.1 74.1 69.3Z",
    className: "c"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M155.3 52.4c3.5 1.7 6 5.3 6 9.5l0 15.6c0 1.7-0.4 3.3-1.2 4.8l-1.3-20.7c-0.2-3.8-0.6-6.9-3.5-9.2Z",
    className: "c"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29 133.6c-2.2 12.3 0.6 23.4 6.3 26.9 -4.2-5.3-6-15.6-4-26.9 0.8-4.6 2.2-8.9 3.9-12.6 -0.5-0.3-1.1-0.6-1.6-0.9 -2 3.7-3.6 8.3-4.5 13.4Z",
    className: "c"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133.9 133.6c2 11.2 0.2 21.5-4 26.9 5.7-3.5 8.4-14.6 6.3-26.9 -0.9-5.2-2.6-9.9-4.7-13.7 -0.5 0.3-1 0.6-1.6 0.9 1.8 3.7 3.2 8.1 4 12.9Z",
    className: "c"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4 125.6c-0.2 2-0.3 4.1-0.3 6.2 0 14 4.4 26.6 11.4 35.5 7 8.9 16.2 14.1 26.1 14.1 9.9 0 19.1-5.1 26.1-14.1 7-8.9 11.4-21.5 11.4-35.5 0-2.2-0.1-4.3-0.3-6.4 -10.9 4-23.6 6-37.5 6 -13.6 0-26.2-1.9-36.9-5.8Z",
    className: "b"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118.7 131.8c0 14.3-4.5 27.2-11.6 36.3 -3.4 4.4-7.3 7.8-11.6 10.3 4.9-2.4 9.4-6.1 13.2-11 7-8.9 11.4-21.5 11.4-35.5 0-2.2-0.1-4.3-0.3-6.4 -0.4 0.2-0.9 0.3-1.3 0.5 0.2 1.9 0.3 3.9 0.3 5.9Z",
    className: "b"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1 131.8c0 14 4.4 26.6 11.4 35.5 7 8.9 16.2 14.1 26.1 14.1 1.1 0 2.3-0.1 3.4-0.2 -27.4-5.1-31.5-33.7-31.5-52.9 -3.1-0.8-6.2-1.7-9.1-2.7 -0.2 2-0.3 4.1-0.3 6.2Z",
    className: "b"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6 161.4l-24.1 0c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2l24.1 0c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2Z",
    className: "a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6 153.3l-24.1 0c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2l24.1 0c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2Z",
    className: "a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6 145.2l-24.1 0c-1.1 0-2-0.9-2-2 0-1.1 0.9-2 2-2l24.1 0c1.1 0 2 0.9 2 2 0 1.1-0.9 2-2 2Z",
    className: "a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKemuBot);
export default __webpack_public_path__ + "static/media/kemu-bot.f74537e7b91270d5247f36e9436f8d5b.svg";
export { ForwardRef as ReactComponent };